import abstractCaseTranslations from "./abstractCaseTranslations";
import personTranslations from "./personTranslations";

const familyLawCaseTranslations = {
  label: "Erstberatung Familienrecht",
  ...abstractCaseTranslations,
  client: personTranslations,
  serviceProvidedDate: {
    label: "Leistung erbracht am",
  },
  advisoryAppointment: {
    label: "Beratungsgespräch",
  },
};

export default familyLawCaseTranslations;
